// /opt/ptg01-v1/front-admin/components/KpiCard.tsx
// Carte compteur du header (mini-dashboard au-dessus des colonnes 2 et 3) — CONVENTIONS.md § 5.
import React from 'react';

export default function KpiCard({ label, value, suffix, icon, color = 'default' }: {
    label: string;
    value: number | string;
    suffix?: string;
    icon?: React.ReactNode;
    color?: 'default' | 'red' | 'green' | 'amber';
}) {
    const colorClass = color === 'red' ? 'text-red-700' : color === 'green' ? 'text-green-700' : color === 'amber' ? 'text-amber-700' : 'text-[#000091]';
    return (
        <div className="bg-white border-2 border-[#000091]/25 rounded-xl px-3 py-2 min-w-0">
            <div className="flex items-center gap-1 text-[9px] font-bold text-black/60 uppercase tracking-wider truncate" title={label}>{icon}{label}</div>
            {/* Valeur et complément coupés à l'étroit (1280 px) : texte entier au survol (2026-10-22). */}
            <div className={`text-[18px] font-bold ${colorClass} mt-0.5 tabular-nums truncate`}
                title={suffix ? `${typeof value === 'number' ? value.toLocaleString('fr-FR') : value} ${suffix}` : undefined}>
                {typeof value === 'number' ? value.toLocaleString('fr-FR') : value}
                {suffix && <span className="text-[11px] font-normal text-black/70 ml-1">{suffix}</span>}
            </div>
        </div>
    );
}
